import { useMutation } from '@tanstack/react-query'
import { postNamedCommand } from '../../../../../service'

export const useCreateInfographicReportRunMutation = () => {
  return useMutation({
    mutationFn: async (body) => {
      const { data } = await postNamedCommand('reports', 'create-infographic-report-run', body)
      return data
    }
  })
}
